import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable, take } from "rxjs";
import {
  CustomDetailComponent,
  DataService,
  NotificationService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  GetEventStockAlertSettingsDocument,
  UpdateEventStockAlertSettingsDocument,
} from "src/generated-gql/graphql";

/**
 * Event stock shortage card (embedded on the Global Settings page). Controls
 * who is warned when an event closes with not enough stock, and whether the
 * purchase order is raised automatically instead of by hand.
 *
 * Values live on GlobalSettings custom fields, which are `internal` — read via
 * the dedicated query and saved via a dedicated mutation, mirroring the
 * Shipping SMS card next to it.
 */
@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./event-stock-alert-settings.component.html",
})
export class EventStockAlertSettingsComponent
  implements CustomDetailComponent, OnInit
{
  entity$: Observable<any>;
  detailForm: FormGroup;

  autoPurchase = false;
  alertEmails = "";
  saving = false;

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.dataService
      .query(GetEventStockAlertSettingsDocument)
      .single$.pipe(take(1))
      .subscribe((res) => {
        const s = res?.eventStockAlertSettings;
        if (s) {
          this.autoPurchase = s.autoPurchaseOnEventClose ?? false;
          this.alertEmails = s.stockShortageAlertEmails ?? "";
          this.cdr.markForCheck();
        }
      });
  }

  save(): void {
    this.saving = true;
    this.dataService
      .mutate(UpdateEventStockAlertSettingsDocument, {
        autoPurchaseOnEventClose: this.autoPurchase,
        stockShortageAlertEmails: this.alertEmails ?? "",
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.saving = false;
          this.notificationService.success("Event stock alert settings updated");
          this.cdr.markForCheck();
        },
        error: () => {
          this.saving = false;
          this.notificationService.error(
            "Failed to update event stock alert settings"
          );
          this.cdr.markForCheck();
        },
      });
  }
}
